export const energy_source = {
  state: {
    energy_sources: []
  },
  mutations: {
    updateEnergySources: function(state, newList) {
      state.energy_sources = newList;
    }
  },
  getters: {
    getAllEnergySources(state) {
      return state.energy_sources;
    },
    getEnergySourceByUUID(state) {
      return function(uuid) {
        return state.energy_sources.find(function(a) {
          return (a.uuid === uuid)
        })
      }
    }
  }
}